/**
 * Whether a given value is [promise-like]{@link PromiseLike}.
 *
 * @param value Value to check if it is promise-like.
 * @returns Whether the provided value is like a promise.
 */
export function isPromiseLike(value: unknown): value is PromiseLike<unknown> {
  return typeof (value as any)?.then === "function";
}
